import TooltipProvider from '@Components/Feedback/Tooltip/Provider';
import InitContainer from '@Containers/InitContainer';
import React, { createContext, useContext, useState } from 'react';
import { ErrorBoundary } from "react-error-boundary";
import { AppErrorHandler } from "../AppErrorHandler";
import RouterContainer from "./RouterContainer";
import SessionContainer from './SessionContainer';

export interface AppContextInterface {
    loading: boolean;
    setLoading(loading: boolean): void;

    version: string|null;
    setVersion(version: string|null): void;
}

const AppContext = createContext<AppContextInterface>({
    loading: true,
    setLoading: () => {},

    version: null,
    setVersion: () => {},
});

export function useAppContext() {
    return useContext(AppContext);
}

export default function AppContainer() {
    const [loading, setLoading] = useState(true);
    const [version, setVersion] = useState<string|null>(null);

    return (
        <ErrorBoundary FallbackComponent={AppErrorHandler}>
            <AppContext.Provider value={{
                loading, setLoading,
                version, setVersion,
            }}>
                <SessionContainer>
                    <InitContainer>
                        <TooltipProvider>
                            <RouterContainer />
                        </TooltipProvider>
                    </InitContainer>
                </SessionContainer>
            </AppContext.Provider>
        </ErrorBoundary>
    );
}
